import { render, staticRenderFns } from "./AddManualNumber.vue?vue&type=template&id=2a5152ac&"
import script from "./AddManualNumber.vue?vue&type=script&lang=js&"
export * from "./AddManualNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports